export const blue = {
  95: '#e5efff',
  90: '#ccdfff',
  80: '#99c0ff',
  70: '#66a0ff',
  60: '#3381ff',
  primary: '#0061ff',
  40: '#004ecc',
  30: '#003a99',
  20: '#002766',
  10: '#001333',
  5: '#00031a',
};
